<template>
  <div class="container">


 <div v-if="message && empty " class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}</div>
   <div class="container-fluid" v-else>
    <div class="row" id="FullRecipt" style="display:block">

        <div class="col-12">
            <!-- Nav tabs -->
            <div class="panal">
                <div class="tab-content">
                    <div id="home" class="row p-3">
                        <div class="col-6 text-center pt-5">

                          <img ID="imagMainPnl" src="../../assets/SU_Logo.png" class="img-responsive" width="150" height="70" />

                        </div>
                         <div class="col-6">

                                <table align="right">

                                        <tr>
                                            <td class="font-weight-bold"><label>Hotline 19050</label></td>
                                        </tr>
                                        <tr>
                                            <td><label>Head Office Kattamia,<br /> Sama Tower 5th Floor,<br /> Ring Road , Cairo, Egypt </label></td>
                                        </tr>
                                        <tr>
                                            <td class="font-weight-bold"><label>www.su.edu.eg</label></td>
                                        </tr>
                                    </table>

                            
                        </div>
                        <div class="col-12 text-center mt-3">
                           <h2 class="text-secondary"><strong>Payment Order</strong> <hr/></h2> 
                            <p>
                                To activate your Application You have 2 business days to pay your application fees otherwise your application will be considered invalid.
                               <br> Please use your Applicant ID NUMBER when making your payment to
                                    <span class="text-blue">Bank Misr </span>Account

                                    Number:<span class="text-danger"> 4330240000014373</span> 

                                    <br><b class="text-bold">-In the case of international and online transfer, Applicant must send us a copy of his receipt To: <span class="text-success"><a href="mailto:Info@su.edu.eg">Info@su.edu.eg</a></span> </b>

                                   <br><b class="text-bold"> -To receive applicant’s payment in full, he must cover any transfer related fees which are to be paid to the bank </b><br />

                                       <br> <b class="text-danger">Please note Application fees are non – refundable </b>

                            </p>
                        </div>
                        <div class="clearfix"></div>
                 <br/>

                        <div class="col-10 mt-3 mx-auto" >
                                <div   class="app-All" id="HeaderDiv">
                                    <div   class="app-stu ">
                                        <div   class=""><strong>Applicant ID :</strong> <span  id="StudentCodetxt" >{{PaymentsList !='undefined' ? PaymentsList[0].ApplicantCode  : ''}}</span></div>
                                    </div>
                                    <div   class="app-stu">
                                        <div   class=""><strong>Applicant Code :</strong> <span id="StudentNametxt" >{{PaymentsList !='undefined' ? PaymentsList[0].FullNameEN : ''}}</span></div>
                                    </div>
                                    <div   class="app-stu">
                                        <div   class=""><strong>For :</strong> <span id="SemesterNametxt" >{{PaymentsList !='undefined' ? PaymentsList[0].SemesterName: ''}}</span></div>
                                    </div>
                                
                                </div>

                                <!-- <div class="app-stu-photo">
                                     <img  src="/img/SU_Logo.6662cd78.png"> --
                                    </div> -->



                                <div class="clearfix"></div>
                                <br/>

                                <div id="PaymentsDiv" class="panel-body mt-4">
                                            <div class="table table-responsive">
                                                <table class="table table-condensed table-striped table-bordered">

                                                    <thead class="text-center">
                                                        <tr class="text-uppercase text-center jumbotron bg-primary">
                                                            <th class="text-center bg-primary"><strong>Payment Type</strong></th>
                                                            <th class="text-center bg-primary"><strong>Description</strong></th>
                                                            <th class="text-center bg-primary"><strong>Amount</strong></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="text-center" id="Paymentstbl">
                                                    <tr>
                                                        
                                                        <td class ="text-center">-- <hr/></td>
                                                        <td class ="text-center">-- <hr/></td>
                                                        <td class ="text-center">{{PaymentsList[0].TotalPayment}} <hr/></td>
                                                    
                                                    </tr>
                                                    <tr>
                                                        <td class ="text-center"></td>
                                                        <td class ="text-center">
                                                                    <table class ="table table-condensed">

                                                                        <thead class ="text-center">
                                                                            <tr class ="text-uppercase text-center jumbotron">
                                                                                <th class ="text-center bg-primary"><strong>Campus</strong></th>
                                                                                <th class ="text-center bg-primary"><strong>Faculty</strong></th>
                                                                            </tr>
                                                                        </thead>
                                                                    </table>
                                                        </td>
                                                        <td class ="text-center"></td>
                                                    </tr>
                                                    <tr v-for="(item,index) in PaymentsList" v-bind:key="index">
                                                                <td class ="text-center">{{item.PaymentTypeNameEN}}</td>

                                                                <td class ="text-center">
                                                                                <table class ="table table-condensed">

                                                                                    <tbody class ="text-center">
                                                                                        <td class ="text-center">{{item.BrancheNameEN}}</td>
                                                                                        <td class ="text-center">{{item.FacultyNameEN}}</td>
                                                                                    </tbody>
                                                                                    <tfoot></tfoot>
                                                                                </table>
                                                                </td>
                                                                <td class ="text-center">{{item.Value}}</td>
                                                                </tr>
                                                    </tbody>
                                                    <tfoot></tfoot>
                                                </table>
                                                <hr />
                                            </div>
                                </div>


                                <div id="PaymentsDateDiv" class="panel-body text-center">
                                    <div class="table table-responsive">
                                        <table class="table table-condensed" style="align-content:flex-end" align="right">

                                            <tbody id="PaymentsDatetbl" width="30%" align="right"></tbody>
                                            <tfoot></tfoot>
                                        </table>
                                        <button type="button" class="btn btn-primary" @click="printPayment()" id="Print"><i class="fa fa-print"></i> Print </button>
                                        <div class="clearfix"></div>
                                        <br />
                                    </div>
                                </div>

                        </div>




                        </div>
                   
                       
                    </div>

                </div>
            </div>
        </div>
   


  
      
    </div>
</div>


</template>

<script>
import ApplicantDataServices from '../../services/Applicant/ApplicantData.services'
export default {
name: 'paymentOrder',
data(){
    return{
        PaymentsList: [''],
        message:'',
        successful:'',
        empty:true,
    }
},
computed:{
currentUser() {
     
      return this.$store.state.auth.user;
       
    }
}
,
mounted(){
ApplicantDataServices.GetApplicantPaymentOrder(this.currentUser.UserIDSerial,this.currentUser.SEMESTERID).then(Response =>{
          this.PaymentsList=Response.data
          this.empty = false
          // eslint-disable-next-line no-console
          console.log(Response)
        }, error => {
              
              this.empty =true
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
            });
 
},
methods:{
    printPayment(){
        document.getElementById('Print').hidden =true
        const prtHtml = document.getElementById('FullRecipt').innerHTML;

// Get all stylesheets HTML
let stylesHtml = '';
for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
  stylesHtml += node.outerHTML;
}

// Open the print window
const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
    
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();
        document.getElementById('Print').hidden =false

    }
}
}
</script>

<style>

.panal {
    background: #fff !important;
    border-radius: 10px;
    
    padding: 0px 0px 20px 0px;
    margin-bottom: 20px !important;
  }

.panal{
  background:#fff !important;
  border-radius:10px;
    border: 1px solid #d4d4d4;
padding:0px 0px 20px 0px;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;

}

.app-All{
    width: 60%;
    float: left;
}
.app-stu{
    border-bottom: 1px #333 dotted;
    padding: 10px 0px;
}

.app-stu .title{
    font-weight: bold;
}
.app-stu .title span {
    font-weight: 100;
}
.app-stu-photo{
    float: right;
    width: 200px;
    border-radius: 10px;
    border: 1px solid #111;
    margin-top: 20px;
}

@media only screen and (max-width: 600px) {
  .panal-header{
       width: 90% !important;
  }
  .app-stu-photo {
  float: none;

 
 
}
}
</style>